<template>
  <v-navigation-drawer style="overflow: hidden" width="256">
    <v-card flat style="background-color: #F5F5F5">
      <v-card-title class="pb-0">
        <div class="text-subtitle-2 mb-2">
          <span class="orange--text text-uppercase">{{ nameGame }}</span><br/>
          {{ nameConfig }}
        </div>
        <v-spacer/>
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn  v-bind="attrs" v-on="on" elevation="0" width="100%" color="blue" class="white--text">
                Utils
              <v-icon dense class="ml-2">mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="pa-0">
            <v-list-item @click="onValidate">
              <v-list-item-title>Validate</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onMakePackage">
              <v-list-item-title>Create Package</v-list-item-title>
            </v-list-item>

            <v-divider/>
            <v-list-item @click="onBuildPatchConfigV1">
              <v-list-item-title>Build Patch Config V1</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onBuildPatchConfigV2">
              <v-list-item-title>Build Patch Config V2</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onSavePatchConfig">
              <v-list-item-title>Save Patch Config</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onResetPatchConfig">
              <v-list-item-title>Reset Patch Config</v-list-item-title>
            </v-list-item>
            <v-divider/>
            <v-list-item @click="onPatchProducts">
              <v-list-item-title>Patch Products</v-list-item-title>
            </v-list-item>

          </v-list>
        </v-menu>
      </v-card-title>
      <v-card-text class="mt-0">
        <r-global-config-view/>
        <r-shared-config-view v-if="!isSharedConfig"/>
      </v-card-text>
    </v-card>

    <v-divider />
    <v-list
      dense
      class="drag__holder py-0"
      background-color="blue"
    >
      <v-list-item class="px-3">
        <v-checkbox
          v-model="dndEnabled"
          label="Reorder menu"
          hide-details
          dense
          class="drag__cb ma-0 pa-0"
        />
        <v-spacer/>

        <v-tooltip
          v-if="!isSavedOrder"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              icon
              color="success"
              @click="saveOrder"
            >
              <v-icon small>mdi-check-circle</v-icon>
            </v-btn>
          </template>
          <span>Save order</span>
        </v-tooltip>

        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              icon
              @click="onResetClick"
              :disabled="isDefaultOrder"
            >
              <v-icon small>mdi-restore</v-icon>
            </v-btn>
          </template>
          <span>Reset to default</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item
        v-if="dndEnabled"
        dense
        class="px-3 mt-n4"
      >
        <span
          class="caption"
          style="font-size: 9px !important; padding-left: 4px;"
        >
          <b style="user-select: none;">Your ID:</b> {{ getMyUID() }}
        </span>
      </v-list-item>
    </v-list>
    <v-divider />

    <v-list dense class="mb-6">
      <draggable
        v-model="dItems"
        item-key="name"
        :disabled="!dndEnabled"
        animation="150"
        handle=".drag-handle"
        ghost-class="drag-ghost"
        tag="div"
      >
        <v-list-item
          v-for="el in dItems"
          :key="el.name"
          :href="el.href"
          :target="el.target"
          :to="!el.href ? { name: el.name } : null"
          color="light-blue darken-3"
        >
          <v-list-item-icon style="margin-right: 16px;">
            <v-icon>{{ el.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ el.title }}</v-list-item-title>

          <v-spacer/>

          <v-btn
            v-if="dndEnabled"
            icon
            small
            color="black"
            class="drag-handle"
            title="Drag to reorder"
          >
            <v-icon small>mdi-drag</v-icon>
          </v-btn>
        </v-list-item>
      </draggable>
    </v-list>

    <r-package-dialog ref="r-package-export"/>
    <r-patch-builder-dialog-v1 ref="patch-builder-dialog-v1"/>
    <r-patch-builder-dialog-v2 ref="patch-builder-dialog-v2"/>
  </v-navigation-drawer>
</template>

<script>

import firebase from "firebase";
import {serialize} from "serializr";
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {TimeUtils} from "@/common/TimeUtils";
import {PackageModel} from "@/modules/redactor/models/package/PackageModel";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import draggable from "vuedraggable";

import {MenuConfig, buildOrdered} from "./MenuConfig";
import RPackageDialog from "@/modules/redactor/views/package/r-package-dialog";
import RGlobalConfigView from "@/modules/redactor/views/global-config/r-global-config-view.vue";
import RSharedConfigView from "@/modules/redactor/views/shared-config/r-shared-config-view.vue";
import RPatchBuilderDialogV1 from "@/modules/redactor/views/patch/r-patch-builder-dialog-v1.vue";
import RPatchBuilderDialogV2 from "@/modules/redactor/views/patch/r-patch-builder-dialog-v2.vue";

const namesOf = (arr) => (Array.isArray(arr) ? arr.map(i => i.name) : []);
const arraysEqual = (a, b) => a.length === b.length && a.every((x, i) => x === b[i]);

export default {
  name: "MenuView",
  components: {
    RGlobalConfigView,
    RSharedConfigView,
    RPackageDialog,
    RPatchBuilderDialogV1,
    RPatchBuilderDialogV2,
    draggable
  },
  props: {
    nameGame: VueTypes.string.def("unknown"),
    nameConfig: VueTypes.string.def("unknown"),
    readonly: VueTypes.bool.def(false)
  },

  data() {
    const base = Array.isArray(MenuConfig) ? [...MenuConfig] : [];

    return {
      dndEnabled: false,
      defaultItems: base,
      baseItems: base,
      dItems: [...base]
    };
  },

  computed: {
    isSavedOrder() {
      return arraysEqual(namesOf(this.baseItems), namesOf(this.dItems));
    },

    isDefaultOrder() {
      return arraysEqual(namesOf(this.defaultItems), namesOf(this.dItems));
    },

    isSharedConfig() {
      return !!this.$route.query.shared;
    },
  },

  created() {
    this.loadOrder();
  },

  methods: {
    getMyUID() {
      return PermissionsStoreUtils.getMyUserUid();
    },

    menuOrderRef() {
      const uid = this.getMyUID();
      if (!uid) throw new Error("User ID is not available.");

      return firebase.database().ref(`/menu_order/${uid}`);
    },

    applyOrder(orderNames = []) {
      this.dItems = buildOrdered(this.defaultItems, orderNames);
    },

    async loadOrder() {
      try {
        const snap = await this.menuOrderRef().get();
        if (!snap.exists()) return;

        const { order } = snap.val() || {};
        if (Array.isArray(order) && order.length) {
          this.applyOrder(order);

          const merged = this.dItems.map(i => i.name);
          if (!arraysEqual(order, merged)) {
            await this.menuOrderRef().set({ order: merged });
          }

          this.baseItems = [...this.dItems];
        }
      } catch (e) {
        console.warn("loadOrder failed:", e);
      }
    },

    async saveOrder() {
      try {
        const order = this.dItems.map(i => i.name);
        await this.menuOrderRef().set({ order });

        this.baseItems = [...this.dItems];
        this.dndEnabled = false;
        this.$alert("Menu order saved.", "Success", "success");
      } catch (e) {
        this.$alert(String(e), "Failed to save menu order", "error", { width: "600px" });
      }
    },

    onResetClick() {
      if (this.isDefaultOrder) return;

      this.$confirm("Are you sure you want to Reset to the default order?")
        .then(() => this.resetToDefaultAndRemove())
        .catch(() => {});
    },

    async resetToDefaultAndRemove() {
      try {
        await this.menuOrderRef().remove();

        this.dItems = [...this.defaultItems];
        this.baseItems = [...this.defaultItems];

        this.$alert("Reset to default. Personal order removed.", "Success", "success");
      } catch (e) {
        this.$alert(String(e), "Failed to reset", "error", { width: "600px" });
      }
    },

    onFlush() {
      this.$store.dispatch("redactor-store/flush").then(() => {
        this.$alert("Flush Config!", "Flush Config", "success");
      }).catch((error) => {
        let reason = error.map(v => JSON.stringify(v)).join(',');
        this.$alert(reason, "Flush Config", "error", {width: '600px'});
      })
    },
    onValidate() {
      this.$store.dispatch("redactor-store/validate").then(() => {
        this.$alert("Valid Config!", "Valid Config", "success");
      }).catch((error) => {
        let reason = error.map(v => JSON.stringify(v)).join(',');
        this.$alert(reason, "Invalid Config", "error", {width: '600px'});
      })
    },
    onMakePackage() {
      this.$refs['r-package-export'].show(ViewRules.UPDATE, null).then(data => {
        let text = JSON.stringify(serialize(PackageModel, data));
        let blob = new Blob([text], {type: "text/plain;charset=utf-8"});
        let fs = require('file-saver');
        fs.saveAs(blob, "package_" + data.uid + ".json");
      }).catch(() => {
      });
    },
    onSavePatchConfig() {
      this.$store.dispatch("redactor-store/buildPatch").then((data) => {
        let blob = new Blob([JSON.stringify(data)], {type: "text/plain;charset=utf-8"});
        let fs = require('file-saver');
        fs.saveAs(blob, "config_patch_" + TimeUtils.now() + ".json");
      }).catch((data) => {
        this.$alert(JSON.stringify(data), "Failed save patch config!", "error", {width: '600px'});
      })
    },
    onResetPatchConfig() {
      this.$store.dispatch("redactor-store/resetPatch").then(() => {
        this.$alert("Completed", "Success reset patch config", "success");
      }).catch((data) => {
        this.$alert(JSON.stringify(data), "Failed reset patch config!", "error", {width: '600px'});
      })
    },
    onPatchProducts() {
      this.$store.dispatch("redactor-store/patchProducts").then(() => {
        this.$alert("Completed", "Success", "success");
      }).catch((data) => {
        this.$alert(JSON.stringify(data), "Failed!", "error", {width: '600px'});
      })
    },
    onBuildPatchConfigV1() {
      this.$refs["patch-builder-dialog-v1"].show();
    },
    onBuildPatchConfigV2() {
      this.$refs["patch-builder-dialog-v2"].show();
    },
  },
}

</script>

<style>
.drag__holder {
  background-color: #FAFAFA !important;
}
.drag__cb label.v-label {
  font-size: 11px !important;
}
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
.drag-ghost {
  opacity: 0.6;
}
</style>
